import React, {useContext, useEffect, useState} from 'react'
import s from '../styles/StudentProfile.module.scss'
import {CareerCard, FeaturedCard, ScholarshipCard} from '../Components/Components'
import {Tile} from 'Components/Tile/Tile'
import {AiFillStar} from 'react-icons/ai'
import Card from 'react-bootstrap/Card'
import {isEmployer, isLoggedIn, isMentee, SessionContext} from 'Utils/sessions';
import avi from 'Static/default-avi.png'
import {Root} from 'Root'
import {countries} from 'Utils/regions'
import {majors} from 'Utils/majors';
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import backgroundImg from 'Static/backgroundImg.png'
import SideBar from 'Components/Nav/SideBar';
import {useLocation} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import {ids} from 'Utils/idToCollege'
import {ScheduleMeeting} from '../../Discover/Components/BookMeeting'
import {InviteApply, ReviewContractor} from '../../Company/components/Component'
import {Message} from '../Components/Message'
import {ConnectionRequest} from '../Components/ConnectionRequest'
import {isMentor} from "../../../Utils/sessions";

const MentorProfile = ({userProfile}) => {
    const {session} = useContext(SessionContext)
    const [profile, setProfile] = useState({});
    const [jobs, setJobs] = useState(null)
    const [experiences, setExperiences] = useState(null)
    const [featured, setFeatured] = useState(null)
    const [awards, setAwards] = useState(null)
    const [awardError, setAwardError] = useState(null)
    const [featuredError, setFeaturedError] = useState(null)
    const [jobError, setJobError] = useState(null)
    const [reviews, setReviews] = useState(null)
    const [reviewsError, setReviewsError] = useState(null)
    const [experienceError, setExperiencesError] = useState(null)
    const username = useLocation().pathname.split("/").at(useLocation().pathname.split("/").length - 1)

    useEffect(() => {
        if (userProfile) {
            setProfile(userProfile)
        } else {
            Root.userApi.fetchMentorProfile(username, session.jwt).then((res) => {
                setProfile(res.data)
            }).catch(() => {
                setProfile({})
            })
        }
    }, [userProfile, username, session.jwt])

    useEffect(() => {
        if (profile?.userName) {
            Root.userApi.getMentorAttribute(profile.userName, "featured_work", session.jwt)
                .then(res => setFeatured(res.data)).catch(
                () => {
                    setFeatured([]);
                    setFeaturedError('Error, please try again later')
                })

            Root.userApi.getMentorAttribute(profile.userName, "accomplishments", session.jwt)
                .then(res => setAwards(res.data)).catch(
                () => {
                    setAwards([]);
                    setAwardError('Error, please try again later')
                })

            Root.userApi.getMentorAttribute(profile.userName, "job_positions", session.jwt)
                .then(res => setJobs(res.data)).catch(
                () => {
                    setJobs([]);
                    setJobError('Error, please try again later')
                })

            Root.userApi.getMentorAttribute(profile.userName, "experiences", session.jwt)
                .then(res => setExperiences(res.data)).catch(
                () => {
                    setExperiences([]);
                    setExperiencesError('Error, please try again later')
                })
        }
    }, [profile.userName, session.jwt])

    return <div className={s.mentorProfile}>
        <SideBar title={"Profile"} session={session}>
            {profile.userName ?
                <>
                    <div className={s.dashboardContent}>
                        {session.userName === profile.userName &&
                            <h2 className={'mb-4'}>Manage your profile</h2>
                        }
                        <div className={s.profileGrid}>
                            <div className={s.col}>
                                <div>
                                    <h3 className='heading'><strong>Information</strong></h3>
                                    <MentorAboutMe session={session} profile={profile}/>
                                </div>
                                {profile.resume && (profile.username === session.username) && <>
                                    <div className='mt-4'>
                                        <h3 className='heading'><strong>Resume</strong></h3>
                                        <Tile className='xlCard' color={'purple'} size={'lg'}>
                                            {profile.resume ?
                                                <a className='btnLink fs-14' target="_blank"
                                                   style={{color: 'rgb(118, 120, 237)'}}
                                                   href={profile.resume}>{profile.firstName}'s Resume</a> : <>
                                                    {profile.userName === session.userName ?
                                                        <a className='btnLink fs-14'
                                                           style={{color: 'rgb(118, 120, 237)'}}
                                                           href={`/mentors/${session.userName}/edit`}>Upload Resume</a>
                                                        : <span className='fs-14' style={{color: 'rgb(118, 120, 237)'}}>No resume</span>}
                                                </>}

                                        </Tile>
                                    </div>
                                </>}
                            </div>
                            <div className={s.col}>
                                <div>
                                    <h3 className='heading'><strong>Career History</strong></h3>
                                    <div className={s.gridTwoCol}>
                                        {jobs ? jobs.map((j) => {
                                                return <CareerCard type='job_positions' job={j}/>
                                            })
                                            : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border"
                                                       role="status"/>}
                                        {jobs && jobs.length === 0 && !jobError &&
                                            <p className='text-muted fs-13'>No experiences</p>}
                                    </div>
                                </div>
                                <div className='mt-5'>
                                    <h3 className='heading'><strong>Accomplishments</strong></h3>
                                    <div className={s.gridTwoCol}>
                                        {awards ? awards.map((a) => {
                                                return <ScholarshipCard award={a}/>
                                            })
                                            : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border"
                                                       role="status"/>}
                                        {awards && awards.length === 0 && !awardError &&
                                            <p className='text-muted fs-13'>No accomplishments</p>}
                                    </div>
                                </div>
                                <div className='mt-5'>
                                    <h3 className='heading'><strong>Extracurriculars</strong></h3>
                                    <div className={s.gridTwoCol}>
                                        {experiences ? experiences.map((e) => {
                                                return <CareerCard type='experiences' job={e}/>
                                            })
                                            : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border"
                                                       role="status"/>}
                                        {experiences && experiences.length === 0 && !experienceError &&
                                            <p className='text-muted fs-13'>No more experiences</p>}
                                    </div>
                                </div>
                                <div className='mt-5'>
                                    <h3 className='heading'><strong>Featured Work</strong></h3>
                                    <div className={s.gridTwoCol}>
                                        {featured ? featured.map((f) => {
                                                return <FeaturedCard type='featured' work={f}/>
                                            })
                                            : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border"
                                                       role="status"/>}
                                        {featured && featured.length === 0 && !featuredError &&
                                            <p className='text-muted fs-13'>No featured work</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                : <Spinner style={{color: "rgb(16, 142, 115)"}} animation="border" role="status"/>}
        </SideBar>
    </div>
}

export default (MentorProfile);


const MentorAboutMe = ({session, profile}) => {
    const [show, setShow] = useState(false)
    const [skills, setSkills] = useState([])
    const [interests, setInterests] = useState([])

    useEffect(() => {
        Root.userApi.getMentorAttribute(profile.userName, "skills", session.jwt)
            .then(res => setSkills(res.data)).catch(
            (err) => console.log(err))
    }, [profile.userName, session.jwt])

    useEffect(() => {
        Root.userApi.getMentorAttribute(profile.userName, "interests", session.jwt)
            .then(res => setInterests(res.data)).catch(
            (err) => console.log(err))
    }, [profile.userName, session.jwt])

    const stars = [];
    for (let i = 0; i < profile.rating; i++) {
        stars.push(<AiFillStar color='orange'/>);
    }

    return <>
        <Card className={`xlCard ${s.profileCard}`}>
            <Card.Img className={s.cardImg} variant="top" src={backgroundImg}/>
            <Card.Body>
                <div className={s.avi} style={{
                    backgroundImage: `url(${profile.photo || avi})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }}/>
                {profile && <>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title className='mt-3'>{profile.firstName} {profile.lastName}</Card.Title>
                        <div className='d-flex justify-content-between'>
                            {stars.map((s, idx) => {
                                return s
                            })}
                            <span style={{fontSize: '12px'}}>({profile.rating})</span>
                        </div>
                    </div>
                    <p className='trunc blue'>{profile.city && !profile.city.includes('N/A') && `${profile.city}, `}
                        {profile.country === 'US' && profile.state !== 'N/A' && profile.state}
                        {profile.country !== 'US' && countries[profile.country]}</p>

                    <div style={{marginTop: "20px"}}>
                        <Card.Text>
                            <span className='d-block'><strong>About Me</strong></span>
                            <span className='text-muted fs-13'>{profile.bio || '-'}</span>
                        </Card.Text>

                    </div>
                </>}
                <Card.Text>
                    <span className='d-block'><strong>Skills</strong></span>
                    <span className='mt-2 d-block'>{skills.map((skill, idx) => {
                        return <Tile className='me-2 fs-13' color='purple'>{skill.skill} {' '}</Tile>
                    })}</span>
                    {skills.length === 0 && <p className='text-muted fs-13'>-</p>}
                </Card.Text>
                <Card.Text>
                    <span className='d-block'><strong>Interests</strong></span>
                    <span className='mt-2 d-block'>{interests.map((interest, idx) => {
                        return <Tile className='me-2 fs-13' color='green'>{interest.interest} {' '}</Tile>
                    })}</span>
                    {interests.length === 0 && <p className='text-muted fs-13'>-</p>}
                </Card.Text>
                <Card.Text>
                    <span className='d-block'><strong>School</strong></span>
                    <span>{ids[profile.college]}</span>
                    <span style={{fontSize: '13px'}}
                          className='text-muted d-block'>{majors[profile.major]} {profile.gpa && `(${profile.gpa} GPA)`}</span>
                </Card.Text>

                {isMentor(session) &&
                    <div className='btnGroup'>
                        {profile.userName !== session.userName && <ConnectionRequest otherUserName={profile.userName}/>}
                    </div>
                }

                {isMentee(session) && profile.userName !== session.userName &&
                    <Button onClick={() => setShow(true)} className='btnFill wide mt-2'>Book Meeting</Button>}

                {isMentee(session) && profile.userName !== session.userName &&
                    <div className='mt-3'>
                        <Message recipient={profile.userName}/>
                    </div>
                }

                {profile.userName === session.userName &&
                    <Button type='link' className='btnOutline wide' href={`/profile/edit`}>Edit
                        Profile</Button>}
                {isEmployer(session) && <InviteApply session={session} studentUserName={profile.userName}/>}
                {isEmployer(session) &&
                    <ReviewContractor session={session} studentUserName={profile.userName}/>}
            </Card.Body>
        </Card>

        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Body>
                <ScheduleMeeting student={profile} ipedsid={profile.college} session={session} isInterview={false}/>
            </Modal.Body>
        </Modal>
    </>
};